import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-globe-icon/jb-globe-icon.css.ts
var jb_globe_icon_css_default = i`:host{font-family:var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}:host{font-size:var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem)}:host{align-items:center;color:rgb(var(--globe-icon-color));display:var(--icon-display, inline-flex);gap:var(--spacing-3xs)}svg{block-size:24px;inline-size:24px;padding:2px}:host(:hover) #meridian{transform:rotateY(180deg)}::slotted(span){white-space:nowrap}#meridian{perspective:inherit;transform-origin:center;transition:transform 1.5s ease-in-out}`;

export {
  jb_globe_icon_css_default
};
